import { Modal } from "antd";
import { Icon } from "Components";

type FirstWhitelistingModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

const FirstWhitelistingModal = ({ open, onClose, onConfirm}: FirstWhitelistingModalProps) => (< Modal
    visible={open}
    onCancel={onClose}
    footer={null}
    closable={false}
    centered
    width={552}
    bodyStyle={{ padding: 0 }}
>
    <div className="pm-modal-container">
        <div className="pm-modal-header">
            <div className="pm-modal-header-left">
                <span className="pm-modal-title">Whitelisting Required Before Launch</span>
            </div>
            <button className="pm-modal-close-icon"
                onClick={onClose}
                aria-label="Close">
                <Icon type="campaignModalClose" />
            </button>
        </div>

        <div className="pm-modal-body">
            <p>Before creating your first campaign, please ensure that whitelisting has been properly configured in your environment.</p>
            <br />
            <p>Whitelisting is required to allow test emails to be delivered successfully and to ensure tracking assets load correctly. Without this configuration, campaigns may fail or produce incomplete results.</p>
            <br />
            <p>You can proceed without completing this step, but Venza strongly recommends reviewing whitelisting requirements in advance.</p>
        </div>

        <div className="pm-modal-footer">
            <div className="pm-modal-footer-actions">
                <button className="pm-btn-plain"
                    onClick={onClose}
                >
                    Close
                </button>
                <button className="pm-btn-primary"
                    onClick={onConfirm}
                >
                    View Whitelisting Guide
                </button>
            </div>
        </div>
    </div>
</Modal >);

export default FirstWhitelistingModal;